/**
 * @description 对url 辅助处理，包括获取参数，添加参数，对象参数化
 * @author lei.you
 * @date 2019/03/07
 *
 * */
import qs from 'qs'
import _ from 'lodash'
export default {
  _getSearchObj(url){
    if(url==undefined){
      url=location.href;
    }
    var urlSearch = new URLSearchParams(url);
    return urlSearch;
  },
    /**
     * @description url 追加参数
     * @param name   在url上追加的key
     * @param value 在url上追加的value
     * @param url 被追加的url 默认是本网页的url
     * @return  string 返回结果
     * */
  append(name,value,url){
    var search = this._getSearchObj(url);
    search.append(name,value);
    return search.toString();
  },
    /**
     * @description url 上删除参数
     * @param name   在url上的key
     * @param url url 默认是本网页的url
     * @return  string 返回结果
     * */
  remove(name,url){
    var search = this._getSearchObj(url);
    search.delete(name);
    return search.toString();
  },
    /**
     * @description 获取 url上的指定参数
     * @param name   获取参数的key
     * @param url 被追加的url 默认是本网页的url
     * @return  {string} 返回结果
     * */
  get(name,url){
    var search = this._getSearchObj(url);
    return search.get(name);
  },
  /**
   * @desc 返回迭代器
   * @param url 被追加的url 默认是本网页的url
   * @return {entries} 返回es6迭代器
   * */
  entries(url){
    var search = this._getSearchObj(url);
    return search.entries();
  },
  /**
   * @desc 对象url参数化 例如{a:1,b:2} => a=1&b=2;
   * @param  object{object}
   * @return {string}
   * */
  params(object){
    if(_.isObject(object)){
      return qs.stringify(object);
    }else{
      throw "illege param type"
    }

    return ;
  },
  /**
   * @desc 获取url参数对象 例如 http://xxx/xxx?a=1&b=2  =>{ a:1,b:2}
   * @param url {string}
   * @return {object}
   * */
  getQueryObject(url){
   // return qs.
    url=url||location.href;
    var search = url.split('?')[1] || ''
    var result = qs.parse(search);
    return result;
  },
  /**
   * @description 返回包含所有name 的数组 fo=1&bo=2&fo=2 返回结果 [1,2]
   * @param name 指定的key
   * @param url 默认是本网页url
   * @return {array} 返回一个数组
   * */
  getAll(name,url){
    var search = this._getSearchObj(url);
    return search.getAll(name);
  },
  /**
   * @description 是否包含某个参数
   * @param name 指定的key
   * @param url 默认是本网页url
   * @return {boolean} 返回一个数组
   * */
  has(name,url){
    var search = this._getSearchObj(url);
    return search.has(name);
  },
  toString(){
    var search = this._getSearchObj(url);
    return search.delete(name);
  },
  forEach(){
    var search = this._getSearchObj(url);
    return search.delete(name);
  }

}
